import {observe} from '@github-ui/selector-observer'
import {on} from 'delegated-events'

const DEFAULT_RECOMMENDED_PLAN = 'premium'
const RECOMMENDATION_MAP: Record<string, Array<Array<string | null>>> = {
  ghes: [
    ['>=2000', null, 'premium-plus'],
    ['>=6000', null, 'premium-plus'],
    ['<6000', null, 'premium-plus'],
    ['<1000', null, 'enterprise'],
    [null, 'high', 'premium-plus'],
    [null, 'standard', 'premium'],
  ],
  'ghec-ghes': [[null, null, 'premium-plus']],
  ghec: [
    ['>=6000', null, 'premium-plus'],
    ['<1000', null, 'enterprise'],
    [null, 'high', 'premium-plus'],
    [null, 'standard', 'premium'],
  ],
}

function displaySelectedPlanFeatures(selectedPlan: string) {
  for (const el of document.querySelectorAll<HTMLElement>('.js-compare-features-item')) {
    if (el.getAttribute('data-plan') === selectedPlan) {
      el.style.display = 'block'
    } else {
      el.style.display = 'none'
    }
  }
}

observe('.js-compare-features-selected', e => {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  displaySelectedPlanFeatures(e.getAttribute('data-default-plan')!)
})

on('click', '.js-compare-features-nav', function (e) {
  e.preventDefault()
  const plan = e.currentTarget.getAttribute('data-plan')
  const selectedTitle = document.querySelector<HTMLElement>('.js-compare-features-selected')

  if (selectedTitle && plan !== null) {
    displaySelectedPlanFeatures(plan)
    selectedTitle.textContent = e.currentTarget.textContent
  }
})

function changeComparisonTableMobilePlan(plan: string) {
  const planNavItem = document.querySelector<HTMLElement>(`.js-compare-features-nav[data-plan="${plan}"]`)
  if (!planNavItem) return

  const selectedTitle = document.querySelector<HTMLElement>('.js-compare-features-selected')
  if (selectedTitle) {
    selectedTitle.textContent = planNavItem.textContent
    selectedTitle.setAttribute('data-default-plan', plan)
  }

  displaySelectedPlanFeatures(plan)
}

function highlightRecommendedPlan(plan: string) {
  for (const el of document.querySelectorAll<HTMLElement>('.js-plan')) {
    if (el.getAttribute('data-plan') === plan) {
      el.setAttribute('data-recommended-plan', 'true')
    } else {
      el.setAttribute('data-recommended-plan', 'false')
    }
  }
}

function iterateRecommendationMap(
  product: undefined | null | string,
  seats: undefined | null | string,
  complexity: undefined | null | string,
): string | undefined {
  if (!product) return
  const selectedProduct = RECOMMENDATION_MAP[product]
  if (!selectedProduct) return

  for (const row of selectedProduct) {
    if ((seats === row[0] || row[0] === null) && (complexity === row[1] || row[1] === null)) {
      if (row[2]) return row[2]
      return
    }
  }
}

function recommendPlan() {
  const dropdowns = document.querySelectorAll('.js-plans-dropdown')
  const data: Record<string, null | string> = {}

  for (const dropdown of dropdowns) {
    const type = dropdown.getAttribute('data-type')
    if (!type) continue
    const value = dropdown.getAttribute('data-value')
    data[type] = value
  }

  const plan = iterateRecommendationMap(data.product, data.seats, data.complexity)
  highlightRecommendedPlan(plan || DEFAULT_RECOMMENDED_PLAN)
  changeComparisonTableMobilePlan(plan || DEFAULT_RECOMMENDED_PLAN)
}

on('click', '.js-plans-dropdown-item', function (e) {
  e.preventDefault()
  const value = e.currentTarget.getAttribute('data-value')
  const parent_el = e.currentTarget.closest('.js-plans-dropdown')
  if (!parent_el) return
  parent_el.removeAttribute('open')
  if (value) parent_el.setAttribute('data-value', value)
  const title_el = parent_el.querySelector('.js-plans-dropdown-title')
  if (title_el) title_el.textContent = e.currentTarget.textContent

  recommendPlan()
})
